import React, { useState } from 'react';
import { Flag, ShieldOff } from 'lucide-react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { apiService, formatApiError } from '../services/api';
import { useToast } from '../hooks/use-toast';

const CATEGORIES = [
  ['harassment', 'Harassment or threats'],
  ['fake_profile', 'Fake profile / catfish'],
  ['inappropriate_content', 'Inappropriate photos or messages'],
  ['scam', 'Scam or asking for money'],
  ['underage', 'Appears to be under 18'],
  ['spam', 'Spam'],
  ['other', 'Something else'],
];

export const ReportUserModal = ({ user, onClose, onDone }) => {
  const [category, setCategory] = useState('harassment');
  const [description, setDescription] = useState('');
  const [blockUser, setBlockUser] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();

  const submit = async () => {
    setSubmitting(true);
    try {
      await apiService.safety.report({ reported_user_id: user.id, category, description: description || null, block_user: blockUser });
      toast({ title: 'Report submitted', description: 'Thank you. Our team will review it.' });
      onDone?.({ blocked: blockUser });
      onClose();
    } catch (e) {
      toast({ title: 'Could not submit report', description: formatApiError(e), variant: 'destructive' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4" data-testid="report-user-modal">
      <div className="bg-white rounded-2xl p-6 w-full max-w-md space-y-4">
        <div className="flex items-center space-x-2">
          <Flag className="w-5 h-5 text-red-500" />
          <h3 className="text-lg font-semibold">Report {user.name}</h3>
        </div>
        <div className="space-y-2">
          {CATEGORIES.map(([value, label]) => (
            <label key={value} className="flex items-center space-x-2 text-sm cursor-pointer">
              <input type="radio" name="report-category" value={value} checked={category === value}
                onChange={() => setCategory(value)} data-testid={`report-category-${value}`} />
              <span>{label}</span>
            </label>
          ))}
        </div>
        <Textarea value={description} onChange={(e) => setDescription(e.target.value.slice(0, 1000))}
          placeholder="Tell us what happened (optional)" rows={3} data-testid="report-description-input" />
        <label className="flex items-center space-x-2 text-sm cursor-pointer">
          <input type="checkbox" checked={blockUser} onChange={(e) => setBlockUser(e.target.checked)} data-testid="report-block-checkbox" />
          <ShieldOff className="w-4 h-4 text-gray-500" />
          <span>Also block {user.name}</span>
        </label>
        <div className="flex space-x-3">
          <Button variant="outline" className="flex-1" onClick={onClose} disabled={submitting} data-testid="report-cancel-btn">Cancel</Button>
          <Button className="flex-1 bg-red-500 hover:bg-red-600 text-white" onClick={submit} disabled={submitting} data-testid="report-submit-btn">
            {submitting ? 'Submitting…' : 'Submit report'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReportUserModal;
